"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function addDisposableDomListener(node, type, handler, useCapture) {
    node.addEventListener(type, handler, useCapture);
    return {
        dispose: function () {
            if (!handler) {
                return;
            }
            node.removeEventListener(type, handler, useCapture);
        }
    };
}
exports.addDisposableDomListener = addDisposableDomListener;
//# sourceMappingURL=Lifecycle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/xterm/lib/ui/Lifecycle.js
// module id = ./node_modules/xterm/lib/ui/Lifecycle.js
// module chunks = 0